import { pstyle } from "../lib/pstyle.js";

// One-off feedback for a failed background write (bookmark/note/lesson/box/
// quiz sync) — see showToast in useCore.js. Self-dismisses; role="alert" so
// it's announced without needing focus.
export default function Toast({ v }) {
  if (!v.toast) return null;
  return (
    <div
      role="alert"
      style={pstyle("position:fixed; left:50%; bottom:24px; transform:translateX(-50%); z-index:50; display:flex; align-items:center; gap:14px; max-width:420px; padding:11px 16px; border-radius:9px; background:oklch(0.24 0.02 40); color:oklch(0.96 0.008 85); font-size:13px; line-height:1.5; box-shadow:0 14px 34px oklch(0.2 0.01 60 / 0.28);")}
    >
      <span>{v.toast}</span>
      <button
        type="button"
        onClick={v.dismissToast}
        style={pstyle("background:none; border:none; padding:0; font:inherit; color:inherit; cursor:pointer; opacity:0.7; flex:none;")}
        aria-label="Fermer"
      >
        ✕
      </button>
    </div>
  );
}
